import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { RobotEnvironmentContext } from '../../../../contexts/general/RobotEnvironmentContext';
import { Button } from '../../../general/Button';
import { ModalScreenPension } from '../../../general/ModalScreen';
import { OverlayHeader } from '../../OverlayHeader';

export const DeleteProgressModal: React.FC<{
    isShown: boolean;
    setIsShown: (val: boolean) => void;
    onDeleteData: () => void;
}> = ({ isShown, setIsShown, onDeleteData }) => {
    const { t } = useTranslation('pension');
    const { environment } = useContext(RobotEnvironmentContext);

    const onClose = () => setIsShown(false);

    const getText = () =>
        environment === 'MyBND' ? t('pension-delete-modal-text-mybnd') : t('pension-delete-modal-text-marketing');

    return (
        <ModalScreenPension isShown={isShown} useStdModalStyle={false} className="mx-auto md:max-w-screen-sm">
            <div className="bg-white md:mx-auto md:rounded-xl p-8">
                <OverlayHeader title={t('pension-delete-modal-title')} onClose={onClose} />
                <div className="flex flex-col gap-6">
                    <div>
                        <span>{getText()}</span>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Button
                            className={`w-full px-4`}
                            buttonType="primary"
                            onClick={() => {
                                onDeleteData();
                                onClose();
                            }}
                        >
                            {t('general-delete-2')}
                        </Button>
                        <Button className={`w-full px-4`} buttonType="secondary" onClick={onClose}>
                            {t('general-cancel')}
                        </Button>
                    </div>
                </div>
            </div>
        </ModalScreenPension>
    );
};
